import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInternetexplorerComponent } from './simple-icons-internetexplorer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInternetexplorerComponent ],
    exports:      [ SimpleIconsInternetexplorerComponent ],
    bootstrap:    []
})
export class SimpleIconsInternetexplorerModule {}
